import React, {Component} from 'react';
import { Map, Polygon, Rectangle, Placemark } from 'react-yandex-maps';

import CONFIG from './../../../SYSTEM/Config.js'

export default class LocationSelector extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            REGION: 77,
            CENTER: props.GPS.length ? props.GPS.length : props.CENTER,
            GPS: props.GPS.length ? props.GPS.length : props.CENTER,
            MAP: false
        }

        this.MAP = false;

        this.setMapRef = this.setMapRef.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (prevProps.GPS !== this.props.GPS && this.props.GPS.length) {
            this.setState({GPS: this.props.GPS})
            this.MAP.panTo(this.props.GPS)
        }
    }

    setMapRef(node) {
        this.MAP = node
    }

    setActiveMap(map) {
        this.activeMAP = map
    }

    onMapClick = (e) => {
        
        const coords = e.get("coords");
        this.setState({GPS: coords});
        this.MAP.panTo(coords)

        const COMPONENT = this;

        this.activeMAP.geocode(coords).then(function (res) {
            let obj = res.geoObjects.get(0);
            let GPS = obj.geometry._coordinates;
            let ADDRESS = obj.getAddressLine()

            COMPONENT.props.selectAdress(ADDRESS)
        });

    }

    render() {
        return (
            <div className="modal_map">
                <Map
                    defaultState={{center: this.state.CENTER, zoom: 12}} 
                    className="the_address_map"
                    instanceRef={this.setMapRef}
                    onLoad={(ymaps) => this.setActiveMap(ymaps)}
                    onClick={this.onMapClick}
                >
                    <Placemark geometry={this.state.GPS} />
                </Map>
            </div>
        );
    }

}